.background {
  background-color: var(--mantine-color-primaryDark-8);
  transition: background-color 0.2s ease;
  border: 2px solid transparent;
}
